/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.IdentityClaimType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.IdentityClaimType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum IdentityClaimType_ {
   /// <summary>
   ///   User Object Unique Identifier (uoid)
   /// </summary>
   UserObjectIdentifier = 1,
   /// <summary>
   ///   Security Identifier (SID) (sid)
   /// </summary>
   SecurityIdentifier = 2,
   /// <summary>
   ///   User Principal Name (upn)
   /// </summary>
   UserPrincipalName = 3,
   /// <summary>
   ///   SWFC Legacy User Principal Id (upid)
   /// </summary>
   UserPrincipalId = 4
}

export const IdentityClaimTypes: IdentityClaimType[] = [
   {
      code: IdentityClaimType_.UserObjectIdentifier,
      literal: 'UserObjectIdentifier',
      description: 'User Object Unique Identifier',
      shortDescription: 'uoid',
      listPriority: 0,

      typeName: "IdentityClaimType"
   },
   {
      code: IdentityClaimType_.SecurityIdentifier,
      literal: 'SecurityIdentifier',
      description: 'Security Identifier (SID)',
      shortDescription: 'sid',
      listPriority: 0,

      typeName: "IdentityClaimType"
   },
   {
      code: IdentityClaimType_.UserPrincipalName,
      literal: 'UserPrincipalName',
      description: 'User Principal Name',
      shortDescription: 'upn',
      listPriority: 0,

      typeName: "IdentityClaimType"
   },
   {
      code: IdentityClaimType_.UserPrincipalId,
      literal: 'UserPrincipalId',
      description: 'SWFC Legacy User Principal Id',
      shortDescription: 'upid',
      listPriority: 0,

      typeName: "IdentityClaimType"
   }
]

export class IdentityClaimType implements IDomainModel {
   code: IdentityClaimType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: IdentityClaimType_): IdentityClaimType {
      return IdentityClaimTypes.find(d => d.code === code)
   }
}
